// extracted by mini-css-extract-plugin
export var button = "button-module--button--mtcvK";
export var buttonSmall = "button-module--buttonSmall--qBC6l";
export var buttonMedium = "button-module--buttonMedium--uPXxf";
export var secondary = "button-module--secondary--UGjw-";